export default "__VITE_ASSET__p8lluPAm__"